import styled from 'styled-components'

export const Alert = styled.div<{ bgColor: string }>`
  border-radius: 5px;
  height: 4rem;
  min-width: 10%;
  margin: 1rem;
  padding: 1rem;
  background: ${({ bgColor }) => bgColor};
  justify-content: left;
  align-items: center;
  display: flex;

  & * {
    white-space: nowrap;
  }
`
